'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, PanResponder, ScrollView} from 'react-native';
import { observer, inject } from 'mobx-react';
import { QPopupLayer as PopupLayer } from '@qnpm/q-popup-layer';

import Constraints from '../../constaints/index';
import Months from './monthRange';
import Weeks from './weekRange';
import Days from './dayRange';
import Custom from './custom';

import styles from './style';


@inject(stores => {
    const {searchDataStore} = stores;
    const {
        filterData,
        filterVisible,
        handleSearchFilter,
        handleSubmit,
        logData,
        userSelect,
        userSelectStr,
        flightType
    } = searchDataStore;

    return {
        filterData,
        filterVisible,
        handleSearchFilter,
        handleSubmit,
        logData,
        userSelect,
        userSelectStr,
        flightType
    };
})

@observer
class SearchFilter extends Component {
    close = (e)=>{
        this.props.handleSearchFilter(e);
        GodEye.log({
            r: 'c_close_btn',
            ...this.props.logData
        })
    };

    submit = (e)=>{
        const {userSelectStr, logData, userSelect} = this.props || {};
        const {tag, weeks, days, startDate, endDate} = userSelect || {};
        GodEye.log({
            r: 'c_travel_range_submit',
            ...logData,
            month_text: userSelectStr,
            months: tag,
            weeks: weeks,
            days: days,
            start: startDate,
            end: endDate

        });
        this.props.handleSubmit(e)
    };


    render() {
        let data = this.props.filterData;
        let {groupedMonths=[]} = data || {};

        hysdk.enableBackGesture({
            enable: !this.props.filterVisible
        });

        return (
            <PopupLayer
                swipeBackControl={true}
                maskClosable={true}
                title='日期偏好'
                perHeight={75}
                onClose = {this.close}
                visible={this.props.filterVisible}
            >
                <View style={styles.container}>
                    <ScrollView style={styles.container}>
                        <Months groupedMonths={groupedMonths}/>
                        <Weeks />
                        {this.props.flightType === Constraints.flightType.roundtrip ?  <Days /> : null}
                        <View style={styles.lineBlock}/>
                        <Custom />
                    </ScrollView>

                    <TouchableOpacity onPress={this.submit}>
                        <View style={styles.submitBtn}>
                            <Text style={styles.submitBtnText}>确定</Text>
                        </View>
                    </TouchableOpacity>
                </View>
            </PopupLayer>
        )
    }
}

export default SearchFilter;
